function activatePost() {
    $('#activate-form #lookupcode').inputmask({
        mask: upp_wristband_activation.uid_mask || "*******[*]",
        autoUnmask: true,
        greedy: false
    });

    $.validator.addMethod("exactlength", function(value, element, param) {
        return this.optional(element) || value.length == param;
    }, $.validator.format("Please enter exactly {0} characters."));

    $('#activate-form').validate({
        rules: {
            lookupcode: {
                required: true,
                //exactlength: 7
            },
        },
        submitHandler: function(form) {
            activateForm(form);
        }

    });

    $('.wba-confirm .cancel').on('click', function(){
        $('#activate-form ol').slideDown(300, 'easeInOutExpo');
        $('.wba-confirm').slideUp(300, 'easeInOutExpo');
        hideResult();
    });

    $('.wba-confirm .confirm').on('click', function(){
        $('#activate-form')
            .addClass('confirmed')
            .trigger('submit');
    });
}

function activateExists(data) {
    $('.wba-guest').slideUp(300);

    let event = upp_wristband_activation.event;
    let instance = upp_wristband_activation.instance;

    if(data.fgt_registrations && data.fgt_registrations.length) {
        let fgt_registration = _.find(data.fgt_registrations, {'event_event': event, 'event_instance': instance});
        if (fgt_registration) {
            passport.estimate(event, instance).done(function(award){
                let activated = moment(fgt_registration.updated_at).format('MMMM Do, YYYY');
                showResult($.validator.format(upp_wristband_activation.messages.activated, [activated]), 'success');
                $('.wba-success-title').text($.validator.format(upp_wristband_activation.messages.success_title, [fgt_registration.frontgate_item_lookup_id]));
                $('.pre-activate').slideUp(300, 'easeInOutExpo');
                $(`#${award.level}-success`).show();
                if (upp_wristband_activation.cashless_enabled) {
                    $('.wba-cashless a.btn-main').attr('href', upp_wristband_activation.cashless_url + fgt_registration.event_registration_directory + '?email=' + encodeURI(data.email) + '&barcode=' + encodeURI(fgt_registration.frontgate_item_lookup_id));
                }
                $('.wba-success').slideDown();
            });
        }
        else {
            $('.wba-form').slideDown();
            $('#activate-form')
                .removeClass('confirmed')
                .find('ol').slideDown(300);
        }
    }
    else {
        $('.wba-form').slideDown();
        $('#activate-form')
            .removeClass('confirmed')
            .find('ol').slideDown(300);
    }
}

function activateForm(form) {
    let lookupcode = $('#lookupcode').val().toUpperCase();

    let event = upp_wristband_activation.event;
    let instance = upp_wristband_activation.instance;

    if ( ! $('#activate-form').hasClass('confirmed') ) {
        showResult(upp_wristband_activation.messages.confirm_alert, 'warning');
        $('#activate-form ol').slideUp(300, 'easeInOutExpo');
        $('.wba-confirm').slideDown(300, 'easeInOutExpo');

        $('#errorscroll').get(0)?.scrollIntoView({behavior: 'smooth'});

        return;
    } else {
        $('.wba-confirm').slideUp(300, 'easeInOutExpo');
    }

    return passport.activateFrontGateRegistration(event, instance, lookupcode)
        .then(function(data, textStatus, jqXHR){
            /*$('#activate-form ol').slideUp(300, 'easeInOutExpo');
            showResult(upp_wristband_activation.messages.success_alert, 'success');
            $('.pre-activate').slideUp(300, 'easeInOutExpo');
            $('.wba-cashless a.btn-main').attr('href', 'https://registration.frontgatetickets.com/#/' + data.fgt_registration.event_registration_directory + '?email=' + data.email + '&barcode=' + data.fgt_registration.frontgate_item_lookup_id);
            $('#'+data.fgt_registration.attendance_estimate.level+'-success').show();
            $('.wba-success').slideDown();*/
            passport.info()
                .then(activateExists)
                .then($('.wba-success').get(0)?.scrollIntoView({behavior: 'smooth'}));
        })
        .catch(function(jqXHR, textStatus, error){
            $(document).trigger('rebuild');

            switch(jqXHR.status) {
                case 401:
                    showResult(errors.token, 'error');
                    break;
                case 404:
                    showResult(upp_wristband_activation.messages.error_invalid, 'error');
                    break;
                case 403:
                    showResult(upp_wristband_activation.messages.error_in_use, 'error');
                    break;
                case 409:
                    showResult(upp_wristband_activation.messages.error_already_claimed, 'error');
                    break;
                default:
                    showResult(upp_wristband_activation.messages.error_default, 'error');
            }

            $('#errorscroll').get(0)?.scrollIntoView({behavior: 'smooth'});
        });
}
